<footer class="footer-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <a routerLink="/" class="logo"><img src="assets/img/logo_new_white.png" style="max-height: 90px;" alt="logo"></a>
                    <p style="margin-top:-10px">
                        Ansi Formazione è l’azienda di riferimento per tutte le persone che vogliono migliorare la propria condizione scolastica e professionale. Formata da un vero gruppo di persone, prima che di professionisti
                    </p>
                    <ul class="social-link">
                        <li><a href="https://www.facebook.com/AnsiFormazione/" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="https://www.instagram.com/ansiformazione_it/" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        <li><a href="https://www.linkedin.com/company/ansi-formazione/?viewAsMember=true" class="d-block" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                    </ul>
                        <div class="row pt-3">
                            <div class="col-12 p-0" align="left">
                                <a href="https://apps.apple.com/it/app/discentya/id6468484981" target="_blank">
                                    <img src="assets/img/applestore-badge-white.png" style="width: 160px;">
                                    <img src="assets/img/googlestore-badge-white.png" class="ms-3" style="width: 160px;">
                                </a>
                            </div>
                        </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3>LINK</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/elenco-corsi">Elenco Corsi</a></li>
                        <li><a routerLink="/validita-attestati">Validità Attestato</a></li>
                        <li><a routerLink="/contatti">Contatti</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>LOGIN</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/">Menù</a></li>
                        <li><a href="#" target="_blank">Docenti/Tutor</a></li>
                        <li><a href="#" target="_blank">Partner</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>DOVE SIAMO</h3>
                    <ul class="footer-contact-info">
                        <li><i class='bx bx-map'></i>Via Giovan Battista Perasso, 46<br>82100 Benevento</li>
                        <li><i class='bx bx-phone-call'></i><a href="tel:+390824482121">Telefono: (+39) 0824-482121</a></li>
                        <li><i class='bx bx-envelope'></i><a href="mailto:formazioneregionale@ansiformazione.it">formazioneregionale@ansiformazione.it</a></li>
                        <li><i class='bx bxs-inbox'></i><a href="tel:+390824482121">Lunedì-Venerdì<br>09:00 ÷ 18:30</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="footer-bottom-area">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-8">
                    <p><i class='bx bx-copyright'></i>2025 Discentya LMS - realizzato da <a target="_blank" href="https://www.discentya.it/">Discentya</a>, piattaforma per la formazione online</p>
                </div>
                <div class="col-lg-2 col-md-2 d-none">
                    <ul>
                        <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
</footer>
